// Routes de la zone /terrain (application terrain, lot L3-C), toutes sous la coquille terrain et sa
// garde de session. Raccordées dans Application.tsx par une seule ligne.
import { EtatVide, LienBouton } from '@cc/ui';
import type { RouteObject } from 'react-router';
import { EnTeteTerrain } from './commun';
import { CoquilleTerrain } from './CoquilleTerrain';
import { PageConflits } from './PageConflits';
import { PageMission } from './PageMission';
import { PageMonTravail } from './PageMonTravail';
import { PageOrdreMission } from './PageOrdreMission';
import { PageReglages } from './PageReglages';
import { PageTournee } from './PageTournee';
import { PagePlace } from './PagePlace';

function PageIntrouvableTerrain() {
  return (
    <>
      <EnTeteTerrain titre="Page introuvable" />
      <EtatVide titre="Cette adresse ne correspond à aucun écran de l'application terrain" niveau={2} action={<LienBouton href="/terrain">Mon travail</LienBouton>} />
    </>
  );
}

export const routesTerrain: RouteObject[] = [
  {
    path: '/terrain',
    element: <CoquilleTerrain />,
    children: [
      { index: true, element: <PageMonTravail /> },
      { path: 'missions/:id', element: <PageMission /> },
      { path: 'tournees/:id', element: <PageTournee /> },
      { path: 'ordres/:id', element: <PageOrdreMission /> },
      { path: 'places/:id', element: <PagePlace /> },
      { path: 'conflits', element: <PageConflits /> },
      { path: 'reglages', element: <PageReglages /> },
      { path: '*', element: <PageIntrouvableTerrain /> },
    ],
  },
];
